query Campaigns {
  campaigns {
    id
    name
  }
}
